var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-page',{attrs:{"image":20}},[_c('h1',[_vm._v(_vm._s(_vm.page.name))])]),_c('div',{staticClass:"body-page"},_vm._l((_vm.page.sections),function(section){return _c('section-component',{key:section.id,attrs:{"page":_vm.page.id,"section":section}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }